import * as languages from "../../constants/languages";
import AccordianRow from "../AccordianRow";
import { english, spanish } from "../../constants/strings";
import { Container } from "../../grid";
import { css, StyleSheet } from "aphrodite";
import Page from "../Page";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

const styles = StyleSheet.create({
	accordianRowContainer: {
		marginBottom: 10,
	},
});

export default class FAQPage extends PureComponent {
	static propTypes = {
		language: PropTypes.string.isRequired,
		pathname: PropTypes.string.isRequired,
		loggedIn: PropTypes.bool,
	};

	constructor(props) {
		super(props);

		this.strings = props.language === languages.es ? spanish : english;
		this.questions = Object.keys(this.strings.faq.questions).map(
			key => this.strings.faq.questions[key],
		);
		this.answers = Object.keys(this.strings.faq.answers).map(
			key => this.strings.faq.answers[key],
		);

		this.state = {
			openQuestion: "",
		};
	}

	_toggleOpen = questionText => {
		this.setState({
			openQuestion: questionText === this.state.openQuestion ? "" : questionText,
		});
	};

	render() {
		return (
			<Page
				activeTab={this.strings.tabNames.FAQ}
				pageTitle={this.strings.tabNames.FAQ}
				currentRoute={this.props.pathname}
				language={this.props.language}
				loggedIn={this.props.loggedIn}
			>
				<Container>
					{this.questions.map((q, i) => (
						<div className={css(styles.accordianRowContainer)} key={q}>
							<AccordianRow
								title={q}
								body={this.answers[i]}
								toggleOpen={this._toggleOpen}
								isOpen={q === this.state.openQuestion}
							/>
						</div>
					))}
				</Container>
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/FAQPage.js